'use client'

import { useEffect, useRef } from 'react'

import { useSettings } from '@core/hooks/useSettings'
import useVerticalNav from '@menu/hooks/useVerticalNav'

const LogoLogin = () => {
  const logoTextRef = useRef<HTMLSpanElement>(null)

  const { isHovered } = useVerticalNav()
  const { settings } = useSettings()

  const { layout } = settings

  useEffect(() => {
    if (layout !== 'collapsed') {
      return
    }

    if (logoTextRef && logoTextRef.current) {
      if (layout === 'collapsed' && !isHovered) {
        logoTextRef.current?.classList.add('hidden')
      } else {
        logoTextRef.current.classList.remove('hidden')
      }
    }
  }, [isHovered, layout])

  return (
    <div className='flex items-center min-bs-[24px]'>
      <div className='bg-white p-4 rounded-lg transition duration-150 ease-in-out hover:scale-110'>
        <img src='/images/icon/logo_bg_white-removebg.png' alt='logo' width={175} height={105} />
      </div>
    </div>
  )
}

export default LogoLogin
